import { Award } from 'lucide-react';

import { TIPOS_BONUS } from '../bonus.api';
import { BonusSolicitudesPage } from './bonus-solicitudes-page';

/**
 * Bonus → Transacciones (`/bonus/transacciones`).
 *
 * Puerto de `Bonus::transaction`: el historial de transacciones enviadas al
 * servicio de Primax (`transactions/api/v3/transaction`).
 */
export function BonusTransaccionesPage() {
  return (
    <BonusSolicitudesPage
      eyebrow="Bonus"
      titulo="Transacciones"
      descripcion="Historial de transacciones enviadas al servicio de Bonus, con el detalle enviado y la respuesta de Primax."
      tipo={TIPOS_BONUS.transacciones}
      mostrarEnviados
      icono={Award}
    />
  );
}
